import './ui/MainApp.css';
import logo from '../imgs/logo.svg';

import { useContext, useEffect, useState } from 'react';


import { ToggleOverlay, UserContext } from './contexts';
import { DevMode } from '../contexts';

import { IconBut } from '../ui/buttons';
import { title } from '../ui/helpers';

import Home from './home';
import Settings from './settings';
import { Overlays } from './more';
import Library from './library';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';



export default function MainApp() {
    const userData = useContext(UserContext);

    const [overlays, setOverlays] = useState(new Map());


    return (
        <ToggleOverlay.Provider value={{
            open: (name, args) => toggleOverlay(true, name, args),
            close: (name) => toggleOverlay(false, name)
        }}>
            <div className="main-app mega-max">
                <div className="max">
                    <Routes>
                        <Route path='' element={<Home />} />
                        {/* Redirect from trailing slash to without */}
                        <Route path='/' element={<Navigate to='/app' replace />}></Route>

                        <Route path="/library" element={<Library />} />
                        <Route path="/settings" element={<Settings />} />
                        
                        <Route path='*' element={<Navigate 
                                to='/app' 
                                state={{error: "Path does not exist ... yet."}} 
                                replace 
                            />}
                        ></Route>
                    </Routes>
                    <Overlays open={overlays} />
                </div>
                <FooterMenu />
            </div>
        </ToggleOverlay.Provider>
    )


    function toggleOverlay(btn, name, args){
        // keep history
        // prevent race conditions
        
        setOverlays(prevList => {
            const newList = new Map(prevList);
            btn? newList.set(name, args || 1) : newList.delete(name);

            return newList
        });
        
    }
}


function FooterMenu() {

    return (
        <footer className="footer-menu br-1 mx-auto">
            <nav className="navbar fw flex mid-align even-space br-1">
                <NavItem name="home" to="/app" end={true}>
                    <i className="fa-solid fa-home"></i>
                </NavItem>
                <NavItem name="library" to="/app/library">
                    <i className="fa-solid fa-folder"></i>
                </NavItem>
                <NavItem name="x-plore" to="/app/xplore">
                    <i className="fa-solid fa-compass"></i>
                </NavItem>
                <NavItem name="squads" to="/app/squads">
                    <i className="fa-solid fa-users"></i>
                </NavItem>
                <NavItem name="settings" to="/app/settings">
                    <i className="fa-solid fa-gears"></i>
                </NavItem>
            </nav>
        </footer>
    )
}

// NEED TP CJHECK HOW VIEWS ARE SWITCH TO 
function NavItem({ children, name, to, end }) {

    return (
        <NavLink className="navlink" end={end} to={to}>
            <div className="flex-col mid-align" style={{gap: "5px"}}>
                <div className="navicon" style={{transform: "scale(1.5)"}}>
                    {children}
                </div>
                <small>{ title(name) }</small>
            </div>
        </NavLink>
    )
}


export function Profilepic({ alt }) {
    const { img } = useContext(UserContext);

    return (<img className='max' src={img} alt={alt ?? ''} />)
}
